import * as Yup from 'yup'

import flow from 'lodash/fp/flow'

import email from '@galo-monitor/forms/validators/email.validator'
import password from '@galo-monitor/forms/validators/password.validator'
import required from '@galo-monitor/forms/validators/required.validator'

const loginSchema = ({ t }) => Yup.object().shape({
  email: flow(
    email({ t }),
    required({ t })
  )(Yup.string()),
  password: flow(
    password({ t }),
    required({ t })
  )(Yup.string()),
  remember: Yup.bool()
})

export default loginSchema
